import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eventPositionTop',
  standalone: false,
})
export class EventPositionTopPipe implements PipeTransform {
  transform(
    layoutTop: number,
    oneHourHeight: number,
    paddingPx: number,
    availableHoursMin: number,
    timeScale: number,
  ): unknown {
    return ((layoutTop - availableHoursMin) / timeScale) * oneHourHeight + paddingPx;
  }
}
